import { DELETE, GET, PATCH, POST } from "../API";

export const getSubscriptionAPICall = (projectId, onSuccess, onError) => {
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/subscription`,
    onSuccess,
    onError
  );
};

export const getNumberOfConfirmedUsersAPICall = (
  projectId,
  onSuccess,
  onError,
  productSlug
) => {
  const slug = productSlug ? `?product_slug=${productSlug}` : "";
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/confirmed_users${slug}`,
    onSuccess,
    onError
  );
};

export const subscribeToOfferAPICall = (
  projectId,
  offerName,
  currency,
  onSuccess,
  onError
) => {
  const data = {
    name: offerName,
    currency: currency,
  };

  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/subscribe_to_offer`,
    data,
    onSuccess,
    onError
  );
};

export const cancelSubscriptionAPICall = (projectId, onSuccess, onError) => {
  DELETE(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/cancel_subscription`,
    onSuccess,
    onError
  );
};

export const getDashboardURLAPICall = (projectId, onSuccess, onError) => {
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/dashboard_url`,
    onSuccess,
    onError
  );
};

export const getOffersAPICall = (onSuccess, onError) => {
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/licensing/offers`,
    onSuccess,
    onError
  );
};

// Dashboard usage (table)
export const getUsageAPICall = (
  projectId,
  data,
  onSuccess,
  onError
) => {
  // Accepts payload like:
  // { start_date, end_date, page, items_per_page, sort_by, ascending }
  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/usage`,
    data,
    onSuccess,
    onError
  );
};

// Dashboard usage cards (current range + delta vs previous range)
export const getUsageCardsAPICall = (
  projectId,
  data,
  onSuccess,
  onError
) => {
  // Accepts payload like: { start_date, end_date }
  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/usage_cards`,
    data,
    onSuccess,
    onError
  );
};

// Embed key usage - per api_key breakdown for website_translation product
export const getEmbedKeyUsageAPICall = (
  projectId,
  params,
  onSuccess,
  onError
) => {
  // Params: { start_date, end_date, page, per_page, sort_by, ascending, term }
  const query = new URLSearchParams();
  if (params.start_date) query.append('start_date', params.start_date);
  if (params.end_date) query.append('end_date', params.end_date);
  if (params.page) query.append('page', params.page);
  if (params.per_page || params.items_per_page) query.append('per_page', params.per_page || params.items_per_page);
  if (params.sort_by) query.append('sort_by', params.sort_by);
  if (params.ascending !== undefined) query.append('ascending', params.ascending);
  if (params.term) query.append('term', params.term);

  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/usage/website_translation/breakdown?${query.toString()}`,
    onSuccess,
    onError
  );
};

// Embed domain usage - per domain breakdown for a specific api_key
export const getEmbedDomainUsageAPICall = (
  projectId,
  params,
  onSuccess,
  onError
) => {
  // Params: { start_date, end_date, api_key_id, page, per_page, sort_by, ascending, term }
  const query = new URLSearchParams();
  if (params.start_date) query.append('start_date', params.start_date);
  if (params.end_date) query.append('end_date', params.end_date);
  if (params.api_key_id) query.append('api_key_id', params.api_key_id);
  if (params.page) query.append('page', params.page);
  if (params.per_page || params.items_per_page) query.append('per_page', params.per_page || params.items_per_page);
  if (params.sort_by) query.append('sort_by', params.sort_by);
  if (params.ascending !== undefined) query.append('ascending', params.ascending);
  if (params.term) query.append('term', params.term);

  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/usage/website_translation/domains?${query.toString()}`,
    onSuccess,
    onError
  );
};

export const canAddApiProjectUsersAPICall = (emails, projectId, onSuccess, onError) => {
  const data = {
    emails: emails,
    project_id: projectId,
  };

  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/licensing/can_add_api_project_users`,
    data,
    onSuccess,
    onError
  );
};

export const getSeatsAPICall = (projectId, params, onSuccess, onError) => {
  const queryString = new URLSearchParams(params).toString();
  
  GET(
    process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/members?${queryString}`,
    onSuccess,
    onError
  );
};

export const getApiKeysAPICall = (projectId, params, onSuccess, onError) => {
  const queryString = new URLSearchParams(params).toString();

  GET(
    process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/api_keys?${queryString}`,
    onSuccess,
    onError
  );
};

export const getPlatformSubscriptionAPICall = (projectId, onSuccess, onError) => {
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/subscription`,
    onSuccess,
    onError
  );
};

export const getPlatformProductsAPICall = (projectId, onSuccess, onError) => {
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/products`,
    onSuccess,
    onError
  );
};

export const getProductUsageAPICall = (projectId, productSlug, params, onSuccess, onError) => {
  const queryString = params ? new URLSearchParams(params).toString() : "";
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/usage/${productSlug}${queryString ? `?${queryString}` : ""}`,
    onSuccess,
    onError
  );
};

export const getProductUsageCardsAPICall = (projectId, productSlug, params, onSuccess, onError) => {
  const queryString = new URLSearchParams(params).toString();
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/usage/${productSlug}/cards?${queryString}`,
    onSuccess,
    onError
  );
};

export const getProductUsageTrendAPICall = (projectId, productSlug, params, onSuccess, onError) => {
  const queryString = new URLSearchParams(params).toString();
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/usage/${productSlug}/trend?${queryString}`,
    onSuccess,
    onError
  );
};

export const getProductUsageBreakdownAPICall = (projectId, productSlug, params, onSuccess, onError) => {
  const queryString = new URLSearchParams(params).toString();
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/usage/${productSlug}/breakdown?${queryString}`,
    onSuccess,
    onError
  );
};

export const subscribeToPlanAPICall = (projectId, planId, currency, onSuccess, onError) => {
  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/subscribe`,
    { plan_id: planId, currency },
    onSuccess,
    onError
  );
};

export const addProductAPICall = (projectId, planId, currency, onSuccess, onError) => {
  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/products/add`,
    { plan_id: planId, currency },
    onSuccess,
    onError
  );
};

export const removeProductAPICall = (projectId, productSlug, onSuccess, onError) => {
  DELETE(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/products/${productSlug}/remove`,
    onSuccess,
    onError
  );
};

export const changeProductPlanAPICall = (projectId, productSlug, planId, currency, onSuccess, onError) => {
  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/products/${productSlug}/change_plan`,
    { plan_id: planId, currency },
    onSuccess,
    onError
  );
};

export const cancelPlatformSubscriptionAPICall = (projectId, onSuccess, onError) => {
  DELETE(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/subscription/cancel`,
    onSuccess,
    onError
  );
};

export const getPlatformDashboardURLAPICall = (projectId, onSuccess, onError) => {
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/products/dashboard_url`,
    onSuccess,
    onError
  );
};

export const getConferenceOrganizersAPICall = (projectId, page, itemsPerPage, sortBy, ascending, onSuccess, onError, status, dateFilters, term) => {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (itemsPerPage) params.append("items_per_page", itemsPerPage);
  if (sortBy) params.append("sort_by", sortBy);
  if (ascending !== undefined && ascending !== null) params.append("ascending", ascending);
  if (status && status !== "all") params.append("status", status);
  if (dateFilters?.start_date) params.append("start_date", dateFilters.start_date);
  if (dateFilters?.end_date) params.append("end_date", dateFilters.end_date);
  if (term) params.append("term", term);

  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/conference_organizers${params.toString() ? "?" + params.toString() : ""}`,
    onSuccess,
    onError
  );
};

export const addConferenceOrganizersAPICall = (projectId, emails, onSuccess, onError) => {
  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/add_conference_organizers`,
    { emails },
    onSuccess,
    onError
  );
};

export const disableConferenceOrganizersAPICall = (projectId, emails, onSuccess, onError) => {
  POST(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/disable_conference_organizers`,
    { emails },
    onSuccess,
    onError
  );
};

export const getConferencesListAPICall = (projectId, page, itemsPerPage, sortBy, ascending, onSuccess, onError, startDate, endDate, term, status) => {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (itemsPerPage) params.append("items_per_page", itemsPerPage);
  if (sortBy) params.append("sort_by", sortBy);
  if (ascending !== undefined && ascending !== null) params.append("ascending", ascending);
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  if (term) params.append("term", term);
  if (status && status !== "all") params.append("status", status);

  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/conferences_list${params.toString() ? "?" + params.toString() : ""}`,
    onSuccess,
    onError
  );
};

export const getConferenceParticipantsBreakdownAPICall = (projectId, conferenceId, onSuccess, onError) => {
  GET(
    process.env.REACT_APP_API_PATH +
      `/public_api/projects/${projectId}/licensing/conferences_list/${conferenceId}/breakdown`,
    onSuccess,
    onError
  );
};